const requestOptions = {
  method: "GET",
  redirect: "follow"
};

const host = process.env.REACT_APP_API_HOST || 'https://marioydaniela.com/api'

const api = () => { }

// Image compression function for mobile camera images
const compressImage = async (file) => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      // Calculate new dimensions based on original size
      let maxSize = 1200;
      let quality = 0.7;

      // More aggressive compression for larger images
      if (file.size > 10 * 1024 * 1024) { // > 10MB
        maxSize = 800;
        quality = 0.5;
      } else if (file.size > 5 * 1024 * 1024) { // > 5MB
        maxSize = 1000;
        quality = 0.6;
      }

      let { width, height } = img;

      if (width > height) {
        if (width > maxSize) {
          height = (height * maxSize) / width;
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width = (width * maxSize) / height;
          height = maxSize;
        }
      }

      canvas.width = width;
      canvas.height = height;

      // Draw and compress
      ctx.drawImage(img, 0, 0, width, height);

      // Convert to blob with compression
      canvas.toBlob((blob) => {
        if (blob) {
          // Create a new file with the compressed blob
          const compressedFile = new File([blob], file.name, {
            type: 'image/jpeg',
            lastModified: Date.now()
          });
          resolve(compressedFile);
        } else {
          resolve(null);
        }
      }, 'image/jpeg', quality);
    };

    img.onerror = () => {
      console.log('Failed to load image for compression');
      resolve(null);
    };

    img.src = URL.createObjectURL(file);
  });
};

const getProducts = async () => {
  try {
    const response = await fetch(`${host}/gifts/products`, requestOptions);
    const result = await response.json();
    return result.products || [];
  } catch (error) {
    console.error('Error fetching products:', error);
    return [];
  }
}

const sendReceipt = async (data) => {
  try {
    // Convert file to base64 if it exists
    let fileBase64 = null;
    if (data.image) {
      try {
        // Check file type to determine if it's an image or PDF
        const isImage = data.image.type.startsWith('image/');
        const isPDF = data.image.type === 'application/pdf';

        if (!isImage && !isPDF) {
          return {
            success: false,
            message: 'Formato de archivo no soportado. Solo se permiten imágenes y archivos PDF.'
          };
        }

        // Only compress if it's an image and it's large
        if (isImage && data.image.size > 2 * 1024 * 1024) { // 2MB limit for compression
          console.log('Image is large, attempting to compress...');

          // Try to compress the image first
          const compressedImage = await compressImage(data.image);
          if (compressedImage) {
            data.image = compressedImage;
            console.log('Image compressed successfully, new size:', compressedImage.size);
          }
        }

        // For PDFs, don't compress, just convert to base64
        if (isPDF) {
          console.log('Processing PDF file, size:', data.image.size);
        }

        fileBase64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();

          // Add timeout for large files
          const timeout = setTimeout(() => {
            reject(new Error('Tiempo de espera agotado al procesar el archivo. Intenta con un archivo más pequeño.'));
          }, 30000); // 30 seconds timeout

          reader.onload = () => {
            clearTimeout(timeout);
            console.log('File converted successfully, size:', reader.result.length);
            resolve(reader.result);
          };
          reader.onerror = (error) => {
            clearTimeout(timeout);
            console.error('Error reading file:', error);
            reject(new Error('Error al procesar el archivo. Por favor, intenta con otro archivo.'));
          };
          reader.readAsDataURL(data.image);
        });
      } catch (fileError) {
        console.error('Error converting file to base64:', fileError);
        return {
          success: false,
          message: fileError.message || 'Error al procesar el archivo. Por favor, intenta con otro archivo.'
        };
      }
    }

    // Create payload with base64 file
    const payload = {
      from: data.from,
      country_code: data.country_code,
      phone: data.phone,
      note: data.note || '',
      product_id: data.product_id,
      image: fileBase64,
      image_name: data.image ? data.image.name : '',
      file_type: data.image ? data.image.type : ''
    };

    // Try different approaches for mobile compatibility
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      }
    };

    // Try without mode first, then with cors if it fails
    let response;
    try {
      response = await fetch(`${host}/gifts/send-receipt`, fetchOptions);
    } catch (firstError) {
      console.log('First attempt failed, trying with CORS mode...');
      response = await fetch(`${host}/gifts/send-receipt`, {
        ...fetchOptions,
        mode: 'cors'
      });
    }

    console.log('Server response status:', response.status, response.statusText);
    console.log('Response headers:', [...response.headers.entries()]);

    if (!response.ok) {
      throw new Error(`Error del servidor: ${response.status} ${response.error}`);
    }

    const result = await response.json();
    console.log('Server response result:', result);
    return result;
  } catch (error) {
    console.error('Error sending receipt:', error);
    console.error('Error details:', {
      name: error.name,
      message: error.message,
      stack: error.stack
    });

    // Handle network errors
    if (error.name === 'TypeError' || error.name === 'NetworkError') {
      return {
        success: false,
        message: 'Error de conexión: No se pudo conectar al servidor. Verifica tu conexión a internet.'
      };
    }

    return {
      success: false,
      message: error.message || 'Error de conexión. Por favor, verifica tu conexión a internet e intenta de nuevo.'
    };
  }
}

export default api;

export { getProducts, sendReceipt };